<template> 
    <div style="background:#fff; margin-top:1px;margin-left:1px;overflow-y:auto;height:91vh; "> 
        <el-tabs   :animated="false" value="first" style="background:white;">
            <el-tab-pane name='first' style=" margin-top:-3px">
                <span slot="label"><i class="iconfont icon-chanchengpinrukuzhuancang1" style="margin-left:5px"></i> 库存明细</span> 
                <div style="line-height:30px; padding-top:3px;height:40px;display:flex;border-bottom:1px solid #389">
                    <div style="width:90px">
                        <i class="iconfont icon-xuanze1" style="color:#409eef;margin-right:5px;margin-left:5px"></i>
                        <span style="color:#409eef;font-weight:600;font-size:12px">产品总库存</span>
                    </div>
                    <el-select v-model="selparam2"  placeholder="请选择列名" clearable size="small" style="width:150px;margin-left:10px  ">
                        <span v-for="item in matCol" :key='item.key'>
                            <el-option :label="item.title" :value="item.key"></el-option>
                        </span>
                    </el-select>
                    
                    <el-input placeholder="请输入查询值" v-model="textparam2" size="small" style="width:320px;height:30px  ">
                        <el-select v-model="oper2" slot="prepend" size="small" style="width:110px;  ">
                            <span v-for="item in operArr" :key='item.IDSEQ'>
                                <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                            </span>
                        </el-select>
                        <el-button size="small" slot="append" icon="el-icon-search" @click="qryMatData" style="color:#409eff"></el-button>
                    </el-input>  
                </div>
                <el-table :data="matData" 
                        border                     
                        class="custom-table-border"       
                        disabled-hover
                        style="overflow:auto;margin-top:1px;"
                        size="small"
                        show-summary
                        :summary-method="getMatSum"
                        @row-click="matClick"
                        :height="255" 
                        ref="refmat"
                        :row-key="getRowKey"
                        highlight-current-row>
                    <el-table-column
                        type="index"
                        label="序号"
                        width="60">
                    </el-table-column>
                    <span  v-for="(item ,index) in matCol" :key="index">   
                        <el-table-column   v-if="item.thide==='N'"
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"                                  
                            sortable
                            :min-width="item.width">
                        </el-table-column> 
                    </span> 
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="80">
                        <template slot-scope="scope">
                            <i class="iconfont icon-chazhao" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link  @click="matView(scope.row )" :underline="false"  ><span style="font-size:10px;margin-right:5px;">查看</span></el-link>
                        </template>
                    </el-table-column>                       
                </el-table>
 
                <div style="line-height:30px; padding-top:2px;height:36px;display:flex;border-bottom:1px solid #389">    
                    <div style="width:80px"> 
                        <i class="iconfont icon-xuanze1" style="color:#289;margin-right:5px;margin-left:5px"></i>
                        <span style="color:#289;font-weight:600;font-size:12px">ASIN库存 </span>
                    </div>
                    <el-select v-model="selparam"  placeholder="请选择列名" clearable size="small" style="width:150px;margin-left:15px; ">
                        <span v-for="item in tabCol" :key='item.key'>
                            <el-option :label="item.title" :value="item.key"></el-option>
                        </span>
                    </el-select>
                    
                    <el-input placeholder="请输入查询值" ref="refqry" v-model="textparam" size="small" style="width:320px; height:30px;  ">
                        <el-select v-model="oper" slot="prepend" size="small" style="width:110px;  ">
                            <span v-for="item in operArr" :key='item.IDSEQ'>
                                <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                            </span>
                        </el-select>
                        <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                    </el-input> 
                </div> 
                <el-table :data="tmpData" 
                        border                  
                        class="custom-table-border"          
                        disabled-hover
                        style="overflow:auto; "
                        v-loading="loading"
                        element-loading-background = "rgba(255, 255, 255, .5)"
                        element-loading-text = "加载中，请稍后..."
                        element-loading-spinner = "el-icon-loading"
                        size="small"
                        ref="reftab"
                        show-summary
                        :summary-method="getSummary"
                        @row-click="rowClick"
                        :height="300" 
                        :row-key="getRowKey"
                        highlight-current-row>
                    <el-table-column
                        type="index"
                        label="序号"
                        width="60">
                    </el-table-column>
                    <span  v-for="(item ,index) in tabCol" :key="index">   
                        <el-table-column   v-if="item.thide==='N'"
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"                                  
                            sortable
                            :min-width="item.width">
                        </el-table-column> 
                    </span>     
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="80">
                        <template slot-scope="scope">
                            <i class="iconfont icon-chazhao" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link  @click="editRec(scope.row )" :underline="false"  ><span style="font-size:10px;margin-right:5px;">查看</span></el-link>
                        </template>
                    </el-table-column>                       
                </el-table>
                <div style="line-height:30px; padding-top:2px;height:34px;display:flex;border-bottom:1px solid #389">    
                    <i class="iconfont icon-xuanze1" style="color:#8389;margin-right:5px;margin-left:5px"></i>
                    <span style="color:#8389;font-weight:600;font-size:12px">亚马逊SKU库存调整明细</span>
                </div> 
                <!-- <el-tabs   :animated="false" value="tab2" style="background:white; ">
                    <el-tab-pane name='tab2'>
                        <span slot="label"><i class="iconfont icon-xuanze1" style="color:#8389;margin-right:5px;margin-left:5px"></i>SKU库存调整明细</span>  -->
                        <el-table :data="chgData" 
                            border                            
                            disabled-hover
                            
                            style="overflow:auto; "
                            size="small"
                            :height="200" 
                            ref="refsku"
                            :row-key="getRowKey"
                            highlight-current-row>
                            <el-table-column
                                type="index"
                                fixed
                                label="序号"
                                width="50">
                            </el-table-column>
                            <span  v-for="(item ,index) in chgCol" :key="index">   
                                <el-table-column   v-if="item.fhide==='N'"
                                    :prop="item.key"
                                    :label="item.title"
                                    show-overflow-tooltip
                                    :align="item.align"                                  
                                    sortable
                                    :min-width="item.width">
                                </el-table-column> 
                            </span> 
                        </el-table>
                    <!-- </el-tab-pane> -->
                    <!-- <el-tab-pane name='tab1'>
                        <span slot="label"><i class="iconfont icon-xuanze1" style="color:#389;margin-right:5px"></i>SKU期初数据明细</span> 
                        <el-table :data="initData" 
                            border                            
                            disabled-hover
                            style="overflow:auto;margin-top:3px;"
                            size="small"
                            :height="200" 
                            :row-key="getRowKey"
                            highlight-current-row>
                            <el-table-column
                            type="index"
                            fixed
                            width="50">
                            </el-table-column>
                            <span  v-for="(item ,index) in initCol" :key="index">   
                                <el-table-column   v-if="item.thide==='N'"
                                    :prop="item.key"
                                    :label="item.title"
                                    show-overflow-tooltip
                                    :align="item.align"                                  
                                    sortable
                                    :min-width="item.width">
                                </el-table-column> 
                            </span> 
                        </el-table>
                    </el-tab-pane>     -->
                 <!-- </el-tabs> -->
            </el-tab-pane>  
            
            <el-tab-pane name='third'>
                <span slot="label"><i class="iconfont icon-shujuku1"></i> 店铺库存调整导入</span> 
                <stk-change style="margin-top:-3px"></stk-change>
            </el-tab-pane>
            <el-tab-pane name='second'>
                <span slot="label"><i class="iconfont icon-yuancailiaoxilie"></i> 产品期初数据维护</span>      
                <sku-init style="margin-top:-3px"></sku-init>         
            </el-tab-pane>
        </el-tabs>
        <!-- 提示 -->
        <el-dialog :visible.sync="promptWin" width="450px" append-to-body :show-close="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div> 
            <span>{{prompt}}</span>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
  
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>  
        </el-dialog>
        <!-- 数据查看 -->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="initWin" :width="dlgWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">ASIN库存详情 </span>
            </div> 
            <!-- <div style="height:89vh;overflow-y:auto"> -->
            <Form ref="addForm" :model="formCol" :label-width="120"    label-position="right" inline >
                <span v-for="(item,index) in tabCol" :key="index" >
                    <FormItem :class="item.key=='MATDESC'?'item-width':'item-width'"  :label="item.title" :prop="item.key" v-if="item.fhide==='N'">                                  
                        <el-checkbox border v-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="formCol[item.key]" style="width:100%"></el-checkbox> 
                        <el-input readonly  type="textarea" :rows="2"  v-else-if="item.key==='MATDESC'"   v-model="formCol[item.key]"></el-input> 
                        <el-input :placeholder="item.holder" type="text" v-else disabled   v-model="formCol[item.key]"></el-input>
                    </FormItem>
                </span>
            </Form>              
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="initWin=false" style="margin-right:5px;">取消</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 产品库存 -->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="matWin" :width="dlgWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">产品库存详情 </span>
            </div> 
            <Form ref="addForm" :model="matRow" :label-width="120"    label-position="right" inline >
                <span v-for="(item,index) in matCol" :key="index" >
                    <FormItem :class="item.key=='MATDESC'?'item-width':'item-width'"  :label="item.title" :prop="item.key" v-if="item.fhide==='N'">                                  
                        <el-checkbox border v-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="matRow[item.key]" style="width:100%"></el-checkbox> 
                        <el-input readonly  type="textarea" :rows="2"  v-else-if="item.key==='MATDESC'"   v-model="matRow[item.key]"></el-input> 
                        <el-input :placeholder="item.holder" type="text" v-else disabled   v-model="matRow[item.key]"></el-input>
                    </FormItem>
                </span>
            </Form>              
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="matWin=false" style="margin-right:5px;">取消</el-button>
                </span>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getTabColOrData,getBaseData } from '../../api/user' 
import skuInit from './sku_init.vue' 
import stkChange from './stk_change.vue'
export default {
    name: 'amz_stockchk',
    data () {
        return {
            matWin:false,
            matRow:{},
            initData:[],
            initCol:[],
            chgData:[],
            chgCol:[],
            dataCount:0,
            rowSize:50,
            current:1,
 
            formCol:{},
            prompt:'', // 
            promptWin:false,
            input_hold:'请输入内容... 按回车键以查询',
            selparam:'ASIN',// select 绑定值
            oper:'like',
            textparam:'', // input 绑定值
            tabCol:[] ,//表列集合
            matData:[],
            tmpData:[] ,// 
            selparam2:'MATNO',// select 绑定值
            oper2:'like',
            textparam2:'',  
            matCol:[],
            disabled:false,
            impWin:false,
            stkid:'',
            v_url:'xuper_auth/getTableRecMany' , //api请求路径      
            v_formurl:'xuper_auth/getTableRecMany', //多记录查询 like模式       
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//corp id
            loading:false,// table加载bool
            type:'create',
            stkArr:[],
            operArr:[],
            treeid:'0',
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止 
            v_admin:this.$cookies.get('v_admin') ,//  
            loadWin:false,
            initWin:false,
            allData:[],
        }
    },
    created () {
        this.getTabCol() //得到 表列数组 
        this.getFormData('') //初始查询表数据   
        this.getMatList()
    },
    components: {
        skuInit,
        stkChange,
    },
    mounted () {  
        getBaseData(this.v_url,'PARENTNO','227243','','','v_sys_base','').then(res=>{
            this.stkArr =res.result
        }) 
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });
        this.$refs.refqry.focus()
         //用户表单新增、编辑、审核、作废权限 :frmid:94供应商资料ID
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','17350','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                console.log(JSON.stringify(row))
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        }) 
    } ,
    computed: {
        tabHeight() {
          return  window.innerHeight -680
        },
 
        dlgWidth: function() {
            return (window.innerWidth - 100) + 'px';
        }, 
    },
    methods: {  
        //对指定列进行合计
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='合计'
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                //if(column.property==='MXQTY'){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(1)
                        }else{
                            return prev
                        }
                    },'')
                //}
            })
            return sums
        },
        getMatSum(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='合计'
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='MXQTY'||column.property==='POQTY'||column.property==='QTY'||column.property==='AMT'||column.property==='OFFICEQTY' ||column.property==='ASINQTY'){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(0)
                        }else{
                            return prev
                        }
                    },'')
                }
            })
            return sums
        },
        //产品
        getMatList(cond){
            getTabColOrData(this.v_formurl,'v_STK_MATQRY','corpid',this.v_corpid,'','','','', cond).then((res) => {              
                this.matData =res.result
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.refmat.doLayout();
                })
            })
        } ,
        //库存调整
        getAdjust(asin){
            getTabColOrData(this.v_formurl,'v_STK_ADJUST','corpid',this.v_corpid,'ASIN',asin,'','',' order by mth desc').then((res) => {              
                this.chgData =res.result
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.refsku.doLayout();
                })
            })
        },
        rowClick(row){
            this.getAdjust(row['ASIN'])
        },
        matClick(row){
            this.getFormData(' and matno=\''+row['MATNO']+'\'')
        },
        editRec(row){
            this.initWin =true
            this.formCol =JSON.parse(JSON.stringify(row))
        },
        matView(row){
            this.matWin =true
            this.matRow =JSON.parse(JSON.stringify(row))
        },
        getRowKey(row){
            return row.IDSEQ
        },
 
        //查询表格数据
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and '+this.selparam+' like \'%' + this.txtparam+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam +this.oper+'\''+this.txtparam+'\''
                }
            }
 
            this.getFormData(cond_ )
        },
        qryMatData(){
            let cond_=''
 
            if (this.selparam2&& this.txtparam2){ //列1
                if (this.oper2==='like'){
                    cond_=cond_+' and  '+this.selparam2+'  like  \'%' + this.txtparam2+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam2  +this.oper2+' \''+this.txtparam2+'\' '
                }
            }
            this.getMatList(cond_ +' order by matno')
        },
        //获取表单数据
        getFormData(cond){
            var vm=this
            this.loading =true
            getTabColOrData(this.v_formurl,'v_INIT_QUERY','corpid',this.v_corpid,'','','','',cond).then((res) => {              
                if (res.code==='200'){
                    this.tmpData=res.result  
                    this.chgData=[]
                    this.initData=[]
                    if (res.result.length>0) {
                        this.$refs['reftab'].setCurrentRow(res.result[0])  
                        this.getAdjust(res.result[0]['ASIN'])
                    }
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.$refs.reftab.doLayout();
                    })
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
                vm.loading =false         
            });            
        },
 
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','17350','LSTSEQ','1' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        thide: res.result[k].THIDE,
                        fhide: res.result[k].FHIDE,
                        disabled: res.result[k].DISABLED,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','17350','LSTSEQ','2' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.matCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        thide: res.result[k].THIDE,
                        fhide: res.result[k].FHIDE,
                        disabled: res.result[k].DISABLED,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','227473','LSTSEQ','1' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.initCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        thide: res.result[k].THIDE,
                        fhide: res.result[k].FHIDE,
                        disabled: res.result[k].DISABLED,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','227471','LSTSEQ','1' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.chgCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        thide: res.result[k].THIDE,
                        fhide: res.result[k].FHIDE,
                        disabled: res.result[k].DISABLED,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                    })
                }
            })
        },
    }
}
 
</script>
<style scoped lang="less" >
    .selinput{
        width:340px;
        margin-left:10px; 
    }
    .colwidth{
        width:140px;
    }
    .colwidth2{
        width:642px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    } 
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
    .item-width2  {
        width: 97%;
    } 
</style>
<style lang="less">
.custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }   
    .el-table__body {
        width: 100%;
        // 使表格兼容safari，不错位
        table-layout: fixed !important;
    }
   .el-table {
    th {
        padding: 0 ;
    }
    thead{
        height: 15px !important;
        color:rgb(128,128, 128);
        font-size:12px;
    }
    td {
        padding: 5px ;
        font-size:11px;
    }   
  }
  .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
